import React from 'react'
import { Link } from 'react-router-dom'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './home.css'

const Home = (props) => {
  return (
    <div className="home-container1">
      <Helmet>
        <title>Sycorax Cats</title>
        <meta property="og:title" content="Sycorax Cats" />
        <link
          rel="canonical"
          href="https://sycorax.uk/"
        />
        <meta
          property="og:url"
          content="https://sycorax.uk/"
        />
      </Helmet>
      <Navigation></Navigation>
      <section className="home-thq-welcome-hero-elm welcome-hero">
        <div>
          <div className="home-thq-welcome-hero-overlay-elm welcome-hero-overlay">
            <div className="home-thq-hero-deco-elm10 hero-deco"></div>
            <div className="home-thq-hero-deco-elm11 hero-deco"></div>
            <div className="home-thq-hero-deco-elm12 hero-deco"></div>
            <div className="home-thq-hero-deco-elm13 hero-deco"></div>
            <div className="home-thq-hero-deco-elm14 hero-deco"></div>
            <div className="home-thq-hero-deco-elm15 hero-deco"></div>
            <div className="home-thq-hero-deco-elm16 hero-deco"></div>
            <div className="home-thq-hero-deco-elm17 hero-deco"></div>
            <div className="home-thq-hero-deco-elm18 hero-deco"></div>
            <div className="home-thq-hero-deco-elm19 hero-deco"></div>
            <div className="home-thq-hero-deco-elm20 hero-deco"></div>
            <div className="home-thq-hero-deco-elm21 hero-deco"></div>
          </div>
        </div>
        <div className="home-thq-welcome-hero-container-elm welcome-hero-container">
          <div className="welcome-hero-content">
            <div className="welcome-hero-badge">
              <svg
                fill="none"
                width="24"
                xmlns="http://www.w3.org/2000/svg"
                height="24"
                stroke="currentColor"
                viewBox="0 0 24 24"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-award"
              >
                <path d="m15.477 12.89l1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526"></path>
                <circle r="6" cx="12" cy="8"></circle>
              </svg>
              <span>GCCF Registered Breeder</span>
            </div>
            <b className="home-thq-hero-title-elm hero-title">
              Welcome to Sycorax Oriental and Siamese
            </b>
            <p className="home-thq-hero-subtitle-elm hero-subtitle">
              North Somerset based dedicated breeders of healthy, happy, and
              well-socialised cats/chaos lords & ladies in a loving home environment. Our focus is on
              temperament, health, acceptable levels of gremlin, and of course GCCF standards.
            </p>
            <div className="home-thq-welcome-hero-actions-elm welcome-hero-actions">
              <Link to="/queen" className="home-navlink">
                <div className="home-thq-btn-elm1 btn-primary btn-lg btn">
                  <span>Meet Our Queen</span>
                </div>
              </Link>
              <a href="/kittens" className="home-link">
                <div className="btn-lg btn btn-secondary">
                  <span>View Litters</span>
                </div>
              </a>
            </div>
          </div>
        </div>
      </section>
      <section className="about-snapshot">
        <div className="about-snapshot-container">
          <div className="about-snapshot-card">
            <div className="about-snapshot-image-wrapper">
              <img
                alt="Breeder with a British Shorthair cat"
                src="/pxl_20260406_163549404.portrait-1500w.jpg"
                className="about-snapshot-img"
              />
            </div>
            <div className="about-snapshot-details">
              <h2 className="section-title">
                About Sycorax
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </h2>
              <p className="section-content">
                <span>
                  Currently home to just one queen, she lives inside the family
                  home with us year round. Kittens are born in the bedroom then
                  stay in there with us until they're a little older at
                  which point they're introduced to their own kitten room
                  for a few weeks and then introductions to the other pets of
                  the house and freedom to cause chaos (safely) at their
                  leisure!
                </span>
                <br></br>
                <br></br>
                <span>
                  Orientals and Siamese are vocal, needy, and absolute lovable
                  gremlins and it&apos;s really important you do your research
                  prior to giving one a home, for both your and the cats sake.
                  They don&apos;t do well in single cat households where their
                  humans are also out for much of the day, when we say
                  they&apos;re needy, we mean it.
                </span>
              </p>
              <div className="about-snapshot-footer">
                <div className="about-snapshot-stat">
                  <span className="about-snapshot-val">GCCF</span>
                  <span className="about-snapshot-label">Registered</span>
                </div>
                <div className="about-snapshot-stat">
                  <span className="about-snapshot-val">Home</span>
                  <span className="about-snapshot-label">Bred</span>
                </div>
                <div className="about-snapshot-stat">
                  <span className="about-snapshot-val">Goblin</span>
                  <span className="about-snapshot-label">energy</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="why-choose">
        <div className="why-choose-container">
          <div className="why-choose-header">
            <h2 className="section-title">Why Choose Sycorax</h2>
            <p className="section-subtitle">
              Excellence in breeding, health, and socialisation.
            </p>
          </div>
          <div className="why-choose-grid">
            <div className="why-choose-item">
              <div className="home-thq-why-choose-icon-box-elm1 why-choose-icon-box">
                <svg
                  fill="none"
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide-shield-check lucide"
                >
                  <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                  <path d="m9 12l2 2l4-4"></path>
                </svg>
              </div>
              <h3 className="why-choose-name">Fully Loaded like nachos</h3>
              <p className="section-content">
                All kittens come with GCCF registration, 5 Generation Pedigree, Fully vaccinated - Microchipped - De-Wormed and flead - 2x Vet checks and a goodie bag to take home with them.
              </p>
            </div>
            <div className="why-choose-item">
              <div className="home-thq-why-choose-icon-box-elm2 why-choose-icon-box">
                <svg
                  fill="none"
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide-heart lucide"
                >
                  <path d="M2 9.5a5.5 5.5 0 0 1 9.591-3.676a.56.56 0 0 0 .818 0A5.49 5.49 0 0 1 22 9.5c0 2.29-1.5 4-3 5.5l-5.492 5.313a2 2 0 0 1-3 .019L5 15c-1.5-1.5-3-3.2-3-5.5"></path>
                </svg>
              </div>
              <h3 className="why-choose-name">Health Screening</h3>
              <p className="section-content">
                All breeding cats undergo extensive health screenings and
                genetic testing to ensure kittens have the best start in life and no preventable surprises later in life.
              </p>
            </div>
            <div className="why-choose-item">
              <div className="home-thq-why-choose-icon-box-elm3 why-choose-icon-box">
                <svg
                  fill="none"
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-cat"
                >
                  <path d="M12 5c.67 0 1.35.09 2 .26c1.78-2 5.03-2.84 6.42-2.26c1.4.58-.42 7-.42 7c.57 1.07 1 2.24 1 3.44C21 17.9 16.97 21 12 21s-9-3-9-7.56c0-1.25.5-2.4 1-3.44c0 0-1.89-6.42-.5-7s4.72.23 6.5 2.23A9 9 0 0 1 12 5m-4 9v.5m8-.5v.5"></path>
                  <path d="M11.25 16.25h1.5L12 17z"></path>
                </svg>
              </div>
              <h3 className="why-choose-name">Kitten Socialisation</h3>
              <p className="section-content">
                Raised in our home around daily life and chaos, our kittens will be well socialized and near enough bomb proof.
              </p>
            </div>
            <div className="why-choose-item">
              <div className="home-thq-why-choose-icon-box-elm4 why-choose-icon-box">
                <svg
                  fill="none"
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide-house lucide"
                >
                  <path d="M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8"></path>
                  <path d="M3 10a2 2 0 0 1 .709-1.528l7-6a2 2 0 0 1 2.582 0l7 6A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                </svg>
              </div>
              <h3 className="why-choose-name">Lifetime Support</h3>
              <p className="section-content">
                No questions too big or too small, Siamese and Orientals are a unique breed and sometimes you just gotta ask "Hey is it normal that she walks into a room and screams at me for no reason" Yes. Yes it is.
              </p>
            </div>
          </div>
        </div>
      </section>
      <div className="home-container2">
        <div className="home-container3">
          <Script
            html={`<script defer data-name="sycorax-interactions">
(function(){
  // No complex animations required as per Animation Level: NONE.
  // Basic accessibility and interactive state handling.

  const heroActions = document.querySelector(".welcome-hero-actions")
  if (heroActions) {
    const buttons = heroActions.querySelectorAll(".btn")
    buttons.forEach((btn) => {
      btn.addEventListener("mouseenter", () => {
        // Instant visual feedback for hover
      })
    })
  }

  // Ensure video plays on all devices
  const bgVideo = document.querySelector(".welcome-hero-video")
  if (bgVideo) {
    bgVideo.play().catch((error) => {
      // Fallback handled by poster attribute
    })
  }
})()
</script>`}
          ></Script>
        </div>
      </div>
      <Footer></Footer>
    </div>
  )
}

export default Home
